import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IUserPaymentMethodsState} from "../reducers/user-payment-methods.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getUserPaymentMethodsState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.userPaymentMethods);

export const getUserPaymentMethods = createSelector(getUserPaymentMethodsState,
  (state: IUserPaymentMethodsState) => state && state.userPaymentMethodsData && state.userPaymentMethodsData.userPaymentMethodsData ? state.userPaymentMethodsData.userPaymentMethodsData : null
);

export const getUserPaymentMethodsLoading = createSelector(getUserPaymentMethodsState,
  (state: IUserPaymentMethodsState) =>
    state && state.userPaymentMethodsData && state.userPaymentMethodsData.loading
);

export const getUserPaymentMethodsLoaded = createSelector(getUserPaymentMethodsState,
  (state: IUserPaymentMethodsState) =>
    state && state.userPaymentMethodsData && state.userPaymentMethodsData.loaded
);
